import React, { useState, useEffect } from "react";
import FeedbackPopup from "../../common/components/popup/feedbackPopup";
import { keyConstants, tireComponent } from "../../constants";
import Utils from "../../utility";
import { LuThumbsUp, LuThumbsDown } from "react-icons/lu";
import { IoInformationCircleOutline } from "react-icons/io5";
import { FaThumbsUp } from "react-icons/fa6";
import ClickOutside from "../../common/components/clickOutside";

const ComponentTable = ({
  thead,
  tbody,
  setImagePopup,
  setOpenReasonPopup,
  openReasonPopup,
  setHoverId,
  hoverId,
  imagesData,
  handleFeedback,
  handleUpdateFeedback,
  feedback,
  questions,
  setComponentFeedback,
  componentFeedback
  // data
}) => {
  const [checks, setChecks] = useState(true);
  const [isCorrect, setIsCorrect] = useState(false);
  const [tooltip, setTooltip] = useState(false);
  const [reasonPopupId, setReasonPopupId] = useState(null);
  const [overrideThumbsUp, setOverrideThumbsUp] = useState(false);
  const [isThumbsUpPopup, setIsThumbsUpPopup] = useState(false);

  const leftRearTire = imagesData?.filter(
    (item) => item.componentName === tireComponent.leftRearTire
  );
  const leftFrontTire = imagesData?.filter(
    (item) => item.componentName === tireComponent.leftFrontTire
  );
  const rightRearTire = imagesData?.filter(
    (item) => item.componentName === tireComponent.rightRearTire
  );
  const rightFrontTire = imagesData?.filter(
    (item) => item.componentName === tireComponent.rightFrontTire
  );

  const leftRearWheel = imagesData?.filter(
    (item) => item.componentName === tireComponent.leftRearWheel
  );
  const leftFrontWheel = imagesData?.filter(
    (item) => item.componentName === tireComponent.leftFrontWheel
  );
  const rightRearWheel = imagesData?.filter(
    (item) => item.componentName === tireComponent.rightRearWheel
  );
  const rightFrontWheel = imagesData?.filter(
    (item) => item.componentName === tireComponent.rightFrontWheel
  );

  const handleImageType = (name) => {
    let allImages = [];
    switch (name) {
      case tireComponent.leftRearTire:
        allImages = leftRearTire;
        break;
      case tireComponent.rightRearTire:
        allImages = rightRearTire;
        break;
      case tireComponent.leftFrontTire:
        allImages = leftFrontTire;
        break;
      case tireComponent.rightFrontTire:
        allImages = rightFrontTire;
        break;
      case tireComponent.leftRearWheel:
        allImages = leftRearWheel;
        break;
      case tireComponent.rightRearWheel:
        allImages = rightRearWheel;
        break;
      case tireComponent.leftFrontWheel:
        allImages = leftFrontWheel;
        break;
      case tireComponent.rightFrontWheel:
        allImages = rightFrontWheel;
        break;
      default:
        allImages = [];
    }
    return allImages;
  };

  const mandatoryChecksStatus = (checkValues) => {
    const sameTireCheck = checkValues?.find(
      (check) =>
        check?.checkName?.toLowerCase() === "sametire" &&
        check?.checkValue?.toLowerCase() === "yes"
    );
    const otherChecksAreNo = checkValues?.every((check) => {
      if (check?.checkName?.toLowerCase() !== "sametire") {
        return check?.checkValue?.toLowerCase() === "no";
      }
      return true;
    });
    if (sameTireCheck && otherChecksAreNo) {
      return "Approved";
    } else {
      return "Denied";
    }
  };

  const handleMandatoryCheckFeedback = (
    item,
    childItem,
    feedbackPresent,
    feedbackType,
    isCorrect
  ) => {
    setComponentFeedback((prev) => ({
      ...prev,
      component: "",
      componentName: "",
      questionText: "",
      systemResult: "",
      feedback: "",
      comment: "",
      feedbackType: ""
    }));
    if (!isCorrect) {
      setOpenReasonPopup(childItem?._id);
    }
    setComponentFeedback((prev) => ({
      ...prev,
      component: item?.componentType,
      questionText: childItem?.checkName || childItem?.questionText,
      feedback: isCorrect ? keyConstants.CORRECT : feedbackPresent?.feedback,
      comment: feedbackPresent?.comment,
      componentName: item.componentName,
      componentLocation: item?.componentLocation,
      systemResult: childItem?.checkValue || childItem?.answer,
      feedbackType
    }));
  };
  const ClearData = () => {
    setComponentFeedback((prev) => ({
      ...prev,
      component: "",
      componentName: "",
      questionText: "",
      systemResult: "",
      feedback: "",
      comment: "",
      feedbackType: ""
    }));
  };

  const handleFeedbackForComponent = (
    item,
    feedbackType,
    feedbackPresent,
    isCorrect,
    status
  ) => {
    setComponentFeedback((prev) => ({
      ...prev,
      component: "",
      componentName: "",
      questionText: "",
      systemResult: "",
      feedback: "",
      comment: ""
    }));
    if (!isCorrect) {
      const prefix = feedbackType === "decisionStatus" ? "decision" : "damage";
      setOpenReasonPopup(`${prefix}-${item?._id}-${status}`);
    }
    setComponentFeedback((prev) => ({
      ...prev,
      component: item?.componentType,
      questionText: item?.element,
      feedback:
        isCorrect === "DAMAGE_CORRECT"
          ? keyConstants.CORRECT
          : isCorrect === "DECISION_CORRECT"
            ? keyConstants.CORRECTLY_ACCEPTED_GEN_AI_CORRECT
            : isCorrect === "OVERRIDE_CORRECT"
              ? keyConstants.CORRECTLY_OVERRIDDEN_GEN_AI_INCORRECT
              : feedbackPresent?.feedback,
      comment: feedbackPresent?.comment,
      componentName: item?.componentName,
      systemResult: item?.systemResults,
      componentLocation: item?.componentLocation,
      feedbackType
    }));
  };

  useEffect(() => {
    if (isCorrect) {
      if (feedback) {
        handleUpdateFeedback();
      } else {
        handleFeedback();
      }
    }
    setIsCorrect(false);
  }, [isCorrect]);

  const showDecisionColumn = !thead?.find((h) => h.name === "Decision Status")
    ?.isECEQueue;

  return (
    <div>
      <table className="w-full">
        <thead>
          <tr className="font-InterBold text-ft15-18 text-black-10">
            {thead.map((item, idx) => {
              if (item?.isECEQueue) {
                return;
              }

              return (
                <td
                  key={idx}
                  className={` bg-darkGrey-30 py-3.5  pl-3.5 ${idx != 0 && "border-l border-grey-60"}`}
                >
                  <div className="flex items-center justify-between">
                    <span className="whitespace-nowrap">{item.name}</span>
                    {item.status && (
                      <span
                        className={`${
                          item.status === "Denied"
                            ? " text-red-10"
                            : item.status === "Approved"
                              ? "font-InterMedium text-green-10"
                              : ""
                        } w-max rounded-full  px-2.5 py-1 font-InterMedium text-ft14-17 `}
                      >
                        {item.status}
                      </span>
                    )}
                  </div>
                </td>
              );
            })}
          </tr>
        </thead>
        <tbody>
          {tbody?.map((item, idx) => {
            const questionValues = questions[item?.componentName] || [];
            const filterQuestionText = questionValues?.filter(
              (item) => item.questionText !== ""
            );

            const mandatoryCheck = mandatoryChecksStatus(item.mandatoryChecks);

            return (
              <>
                {!item?.isMoreDetailsAvaialble &&
                  !item?.isSameTireAvaialble && (
                    <tr key={idx} className=" border-grey-30 bg-white">
                      <td className="mb-1 w-15per py-3.5 pl-3.5 font-InterRegular text-ft10-18.15 text-grey-50">
                        <div>{item.element}</div>
                      </td>
                      <td className="w-20per border-l border-grey-60 pl-3.5 font-InterRegular text-ft10-18.15 text-black-10">
                        <div className="flex justify-between pr-3">
                          {item.claimData?.toLowerCase() === "n"
                            ? "No"
                            : item?.claimData?.toLowerCase() === "y"
                              ? "Yes"
                              : item.claimData}
                        </div>
                      </td>
                      <td
                        onMouseEnter={() => {
                          if (!openReasonPopup)
                            setHoverId(
                              `damage-${item?._id}-${item?.systemResults}`
                            );
                        }}
                        onMouseLeave={() => {
                          if (!openReasonPopup) setHoverId(null);
                        }}
                        className="w-20per border-l border-grey-60 px-3.5 font-InterRegular text-ft10-18.15 text-black-10"
                      >
                        <div className="flex items-center justify-between">
                          <span>
                            {item.systemResults?.toLowerCase() === "n"
                              ? "No"
                              : item.systemResults?.toLowerCase() === "y"
                                ? "Yes"
                                : item.systemResults}
                          </span>
                          {item?.processingStatus === "Success" &&
                            item.feedbackDamage && (
                              <div className="relative flex gap-3">
                                {hoverId ===
                                  `damage-${item?._id}-${item?.systemResults}` &&
                                  item?.feedbackDamage && (
                                    <img
                                      onClick={() =>
                                        setImagePopup((prev) => ({
                                          ...prev,
                                          popup: true,
                                          allImages: handleImageType(
                                            item.componentName
                                          ),
                                          idx: 0
                                        }))
                                      }
                                      src="/images/image-logo.svg"
                                      alt=""
                                      className="cursor-pointer"
                                    />
                                  )}
                                {item?.feedbackDamage?.feedback !== "CORRECT" &&
                                item?.feedbackDamage?.feedback !==
                                  "GEN_AI_CORRECT_INSUFFICIENT_INPUTS" ? (
                                  <img
                                    onClick={() => {
                                      setIsThumbsUpPopup(false);
                                      setOpenReasonPopup(
                                        `damage-${item?._id}-${item?.systemResults}`
                                      );
                                      handleFeedbackForComponent(
                                        item,
                                        "damageResults",
                                        item?.feedbackDamage,
                                        false,
                                        item?.systemResults
                                      );
                                    }}
                                    src="/images/red-thumbs-down.svg"
                                    alt=""
                                    className="cursor-pointer"
                                  />
                                ) : (
                                  <FaThumbsUp
                                    onClick={() => {
                                      setIsThumbsUpPopup(true);
                                      setOpenReasonPopup(
                                        `damage-${item?._id}-${item?.systemResults}`
                                      );
                                      handleFeedbackForComponent(
                                        item,
                                        "damageResults",
                                        item?.feedbackDamage,
                                        false,
                                        item?.systemResults
                                      );
                                    }}
                                    className={`cursor-pointer ${item?.feedbackDamage?.feedback === "GEN_AI_CORRECT_INSUFFICIENT_INPUTS" ? "text-black-0" : ""}`}
                                  />
                                )}
                                {openReasonPopup ===
                                  `damage-${item?._id}-${item?.systemResults}` && (
                                  <FeedbackPopup
                                    setState={() => {
                                      setOpenReasonPopup(null);
                                      setIsThumbsUpPopup(false);
                                    }}
                                    elementData={componentFeedback}
                                    setElementData={setComponentFeedback}
                                    handleFeedback={handleFeedback}
                                    handleUpdateFeedback={handleUpdateFeedback}
                                    edit={true}
                                    clearData={ClearData}
                                    isThumbsUp={isThumbsUpPopup}
                                  />
                                )}
                              </div>
                            )}
                          {item?.processingStatus === "Success" &&
                            hoverId ===
                              `damage-${item?._id}-${item?.systemResults}` &&
                            !item?.feedbackDamage && (
                              <div className="relative flex gap-3">
                                <img
                                  onClick={() =>
                                    setImagePopup((prev) => ({
                                      ...prev,
                                      popup: true,
                                      allImages: handleImageType(
                                        item.componentName
                                      ),
                                      idx: 0
                                    }))
                                  }
                                  src="/images/image-logo.svg"
                                  alt=""
                                  className="cursor-pointer"
                                />
                                <LuThumbsUp
                                  className="cursor-pointer"
                                  onClick={() => {
                                    setIsCorrect("DAMAGE_CORRECT");
                                    handleFeedbackForComponent(
                                      item,
                                      "damageResults",
                                      null,
                                      "DAMAGE_CORRECT",
                                      item?.systemResults
                                    );
                                  }}
                                />

                                <LuThumbsDown
                                  className="cursor-pointer"
                                  onClick={() => {
                                    setIsThumbsUpPopup(false);
                                    setOpenReasonPopup(
                                      `damage-${item?._id}-${item?.systemResults}`
                                    );
                                    setIsCorrect(false);
                                    handleFeedbackForComponent(
                                      item,
                                      "damageResults",
                                      null,
                                      false,
                                      item?.systemResults
                                    );
                                  }}
                                />
                                {openReasonPopup ===
                                  `damage-${item?._id}-${item?.systemResults}` && (
                                  <FeedbackPopup
                                    setState={() => {
                                      setOpenReasonPopup(null);
                                      setIsThumbsUpPopup(false);
                                    }}
                                    elementData={componentFeedback}
                                    setElementData={setComponentFeedback}
                                    handleFeedback={handleFeedback}
                                    handleUpdateFeedback={handleUpdateFeedback}
                                    callUpdate={feedback ? true : false}
                                    isForCorrect={isCorrect}
                                    clearData={ClearData}
                                    isThumbsUp={isThumbsUpPopup}
                                  />
                                )}
                              </div>
                            )}
                        </div>
                      </td>
                      <td className="text-black-1 w-20per border-l border-grey-60 pl-3.5 font-InterRegular text-ft10-18.15 ">
                        {item.result}
                      </td>
                      {showDecisionColumn && (
                        <td
                          onMouseEnter={() => {
                            if (
                              !openReasonPopup &&
                              item?.version !== undefined &&
                              item?.decisionStatus
                            )
                              setHoverId(
                                `decision-${item?._id}-${item.decisionStatus}`
                              );
                          }}
                          onMouseLeave={() => {
                            if (!openReasonPopup) setHoverId(null);
                          }}
                          className="w-30per border-l  border-grey-60 pl-3.5"
                        >
                          <div className="flex justify-between pr-2">
                            {item?.decisionStatus ? (
                              <div className="flex flex-row items-center gap-1">
                                <span
                                  className={`${
                                    item.decisionStatus ===
                                    "Accepted By Adjuster"
                                      ? " bg-green-10 bg-opacity-[.2] text-green-10"
                                      : item.decisionStatus ===
                                          "Overridden By Adjuster"
                                        ? "bg-blue-50 text-blue-40"
                                        : "bg-grey-100 bg-opacity-[.5] text-black-20 text-opacity-[.8]"
                                  } w-max rounded-full  px-2.5 py-1 font-InterMedium text-ft14-17 `}
                                >
                                  {item?.decisionStatus}
                                </span>

                                {item?.decisionReason && (
                                  <div className="relative">
                                    <ClickOutside
                                      isOpen={
                                        reasonPopupId === `reason-${item?._id}`
                                      }
                                      onClickOutside={() =>
                                        setReasonPopupId(null)
                                      }
                                    >
                                      <IoInformationCircleOutline
                                        onClick={() =>
                                          setReasonPopupId(
                                            reasonPopupId ===
                                              `reason-${item?._id}`
                                              ? null
                                              : `reason-${item?._id}`
                                          )
                                        }
                                        className="size-5 cursor-pointer text-black-0"
                                      />
                                      {reasonPopupId ===
                                        `reason-${item?._id}` && (
                                        <div className="shadow-lg absolute left-0 top-7 z-50 w-[250px] rounded-lg border border-grey-10 bg-white p-3">
                                          <span className="font-InterMedium text-ft14-17 text-black-10">
                                            {item?.decisionReason}
                                          </span>
                                        </div>
                                      )}
                                    </ClickOutside>
                                  </div>
                                )}
                              </div>
                            ) : (
                              <span>-</span>
                            )}
                            {item?.decisionStatus && item.feedbackDecision && (
                              <div className="relative flex gap-3">
                                {hoverId ===
                                  `decision-${item?._id}-${item.decisionStatus}` &&
                                  item?.feedbackDecision && (
                                    <img
                                      onClick={() =>
                                        setImagePopup((prev) => ({
                                          ...prev,
                                          popup: true,
                                          allImages: handleImageType(
                                            item.componentName
                                          ),
                                          idx: 0
                                        }))
                                      }
                                      src="/images/image-logo.svg"
                                      alt=""
                                      className="size-4 cursor-pointer"
                                    />
                                  )}
                                {item?.feedbackDecision?.feedback !==
                                  "CORRECT" &&
                                item?.feedbackDecision?.feedback !==
                                  keyConstants.CORRECTLY_ACCEPTED_GEN_AI_CORRECT &&
                                item?.feedbackDecision?.feedback !==
                                  keyConstants.CORRECTLY_OVERRIDDEN_GEN_AI_INCORRECT &&
                                item?.feedbackDecision?.feedback !==
                                  keyConstants.CORRECTLY_OVERRIDDEN_GEN_AI_CORRECT ? (
                                  <img
                                    onClick={() => {
                                      setOpenReasonPopup(
                                        `decision-${item?._id}-${item.decisionStatus}`
                                      );
                                      handleFeedbackForComponent(
                                        item,
                                        "decisionStatus",
                                        item?.feedbackDecision,
                                        false,
                                        item.decisionStatus
                                      );
                                    }}
                                    src="/images/red-thumbs-down.svg"
                                    alt=""
                                    className="size-4 cursor-pointer"
                                  />
                                ) : (
                                  <FaThumbsUp
                                    onClick={() => {
                                      setOpenReasonPopup(
                                        `decision-${item?._id}-${item.decisionStatus}`
                                      );
                                      handleFeedbackForComponent(
                                        item,
                                        "decisionStatus",
                                        item?.feedbackDecision,
                                        false,
                                        item?.decisionStatus
                                      );
                                    }}
                                    className="size-4 cursor-pointer"
                                  />
                                )}
                                {openReasonPopup ===
                                  `decision-${item?._id}-${item.decisionStatus}` && (
                                  <FeedbackPopup
                                    setState={() => setOpenReasonPopup(null)}
                                    elementData={componentFeedback}
                                    setElementData={setComponentFeedback}
                                    handleFeedback={handleFeedback}
                                    handleUpdateFeedback={handleUpdateFeedback}
                                    edit={true}
                                    clearData={ClearData}
                                    isDecisionStatus={
                                      item?.decisionStatus ===
                                      "Accepted By Adjuster"
                                        ? "accepted"
                                        : "overriden"
                                    }
                                  />
                                )}
                              </div>
                            )}
                            {hoverId ===
                              `decision-${item?._id}-${item.decisionStatus}` &&
                              !item?.feedbackDecision &&
                              item?.decisionStatus &&
                              item?.version && (
                                <div className="relative flex gap-3">
                                  <img
                                    onClick={() =>
                                      setImagePopup((prev) => ({
                                        ...prev,
                                        popup: true,
                                        allImages: handleImageType(
                                          item.componentName
                                        ),
                                        idx: 0
                                      }))
                                    }
                                    src="/images/image-logo.svg"
                                    alt=""
                                    className="size-4 cursor-pointer"
                                  />
                                  <LuThumbsUp
                                    className="cursor-pointer"
                                    onClick={() => {
                                      if (
                                        item?.decisionStatus ===
                                        "Accepted By Adjuster"
                                      ) {
                                        setIsCorrect("DECISION_CORRECT");
                                        handleFeedbackForComponent(
                                          item,
                                          "decisionStatus",
                                          null,
                                          "DECISION_CORRECT",
                                          item?.decisionStatus
                                        );
                                      } else {
                                        setOverrideThumbsUp(true);
                                        setOpenReasonPopup(
                                          `decision-${item?._id}-${item.decisionStatus}`
                                        );
                                        handleFeedbackForComponent(
                                          item,
                                          "decisionStatus",
                                          null,
                                          false,
                                          item?.decisionStatus
                                        );
                                      }
                                    }}
                                  />

                                  <LuThumbsDown
                                    className="cursor-pointer"
                                    onClick={() => {
                                      setOverrideThumbsUp(false);
                                      setOpenReasonPopup(
                                        `decision-${item?._id}-${item.decisionStatus}`
                                      );
                                      setIsCorrect(false);
                                      handleFeedbackForComponent(
                                        item,
                                        "decisionStatus",
                                        null,
                                        false,
                                        item.decisionStatus
                                      );
                                    }}
                                  />
                                  {openReasonPopup ===
                                    `decision-${item?._id}-${item.decisionStatus}` && (
                                    <FeedbackPopup
                                      setState={() => {
                                        setOpenReasonPopup(null);
                                        setOverrideThumbsUp(false);
                                      }}
                                      elementData={componentFeedback}
                                      setElementData={setComponentFeedback}
                                      handleFeedback={handleFeedback}
                                      handleUpdateFeedback={
                                        handleUpdateFeedback
                                      }
                                      callUpdate={feedback ? true : false}
                                      isForCorrect={isCorrect}
                                      clearData={ClearData}
                                      isDecisionStatus={
                                        item?.decisionStatus ===
                                        "Accepted By Adjuster"
                                          ? "accepted"
                                          : "overriden"
                                      }
                                      isOverrideThumbsUp={overrideThumbsUp}
                                    />
                                  )}
                                </div>
                              )}
                          </div>
                        </td>
                      )}
                    </tr>
                  )}

                {item.isMoreDetailsAvaialble && (
                  <tr className="bg-white font-InterBold text-ft15-18 text-black-10 ">
                    <td colSpan={5} className="px-3">
                      <div className=" flex h-12 w-full justify-between  gap-3 bg-darkGrey-30 p-4">
                        <span>Mandatory Checks & Additional Questions </span>
                        <span className="font-PoppinsMedium">
                          Total Processing Time - {item.slaTime} Seconds
                        </span>
                      </div>
                    </td>
                  </tr>
                )}

                {item.isMoreDetailsAvaialble && (
                  <>
                    <tr className="bg-white">
                      <td colSpan="5">
                        <div className=" px-6 py-2 text-red-10">
                          {item?.errorMessage}
                        </div>
                      </td>
                    </tr>
                    <tr className=" bg-white">
                      <td colSpan="5">
                        <div className=" flex w-full gap-3 px-6 py-2">
                          <div
                            onClick={() => setChecks(true)}
                            className={`flex h-8 w-max cursor-pointer items-center justify-center rounded-md border p-2 text-ft14-17 ${checks ? "border-black-0 text-black-10" : "border-grey-30 text-black-20"}`}
                          >
                            <span className=" font-InterMedium">Checks</span>
                          </div>
                          <div
                            onClick={() => setChecks(false)}
                            className={`flex h-8 w-max cursor-pointer items-center justify-center rounded-md border p-2 text-ft14-17 ${!checks ? "border-black-0 text-black-10" : "border-grey-30 text-black-20"}`}
                          >
                            <span className=" font-InterMedium">
                              Description
                            </span>
                          </div>
                        </div>

                        {checks ? (
                          <div className="flex w-full flex-col">
                            {item.mandatoryChecks?.length > 0 && (
                              <div className="w-full px-6 py-2">
                                <div className="flex w-full justify-between">
                                  <span className="font-InterRegular text-ft14-17  text-black-20">
                                    Mandatory Checks
                                  </span>
                                  <span
                                    className={`font-InterRegular text-ft14-17 ${mandatoryCheck === "Approved" ? "text-green-10" : "text-red-10"} `}
                                  >
                                    {mandatoryCheck}
                                  </span>
                                </div>

                                <div className="flex flex-col gap-3 rounded-md bg-grey-110 p-4">
                                  {item.mandatoryChecks?.map((itm, idx) => {
                                    const feedbackPresent =
                                      item?.mandatoryFeedback?.find(
                                        (value) =>
                                          value.questionText ===
                                            itm?.checkName &&
                                          value.componentName ===
                                            item?.componentName
                                      );

                                    return (
                                      <div
                                        key={idx}
                                        className="flex justify-between"
                                      >
                                        <span className="font-InterRegular text-ft14-17 text-black-10">
                                          {itm.checkName
                                            .replace(/([A-Z])/g, " $1")
                                            .trim()
                                            .replace(/^./, (str) =>
                                              str.toUpperCase()
                                            )}
                                        </span>
                                        <div className="flex gap-2">
                                          <span className="font-InterMedium text-ft14-17 text-black-10">
                                            {itm?.checkValue === "y"
                                              ? "Yes"
                                              : itm?.checkValue === "n"
                                                ? "No"
                                                : Utils.formatText(
                                                    itm.checkValue
                                                  )}
                                          </span>
                                          <div className="relative cursor-pointer">
                                            {feedbackPresent ? (
                                              feedbackPresent?.feedback !==
                                                "CORRECT" &&
                                              feedbackPresent?.feedback !==
                                                "GEN_AI_CORRECT_INSUFFICIENT_INPUTS" ? (
                                                <img
                                                  onClick={() => {
                                                    setIsCorrect(false);
                                                    setIsThumbsUpPopup(false);
                                                    handleMandatoryCheckFeedback(
                                                      item,
                                                      itm,
                                                      feedbackPresent,
                                                      "mandatoryChecks"
                                                    );
                                                  }}
                                                  src="/images/red-thumbs-down.svg"
                                                  alt=""
                                                  className="cursor-pointer"
                                                />
                                              ) : (
                                                <FaThumbsUp
                                                  onClick={() => {
                                                    setIsCorrect(false);
                                                    setIsThumbsUpPopup(true);
                                                    handleMandatoryCheckFeedback(
                                                      item,
                                                      itm,
                                                      feedbackPresent,
                                                      "mandatoryChecks"
                                                    );
                                                  }}
                                                  className={`cursor-pointer ${feedbackPresent?.feedback === "GEN_AI_CORRECT_INSUFFICIENT_INPUTS" ? "text-black-0" : ""}`}
                                                />
                                              )
                                            ) : (
                                              <div className="flex gap-2">
                                                <LuThumbsUp
                                                  onClick={() => {
                                                    setIsCorrect(true);
                                                    handleMandatoryCheckFeedback(
                                                      item,
                                                      itm,
                                                      feedbackPresent,
                                                      "mandatoryChecks",
                                                      true
                                                    );
                                                  }}
                                                />
                                                <LuThumbsDown
                                                  className="cursor-pointer"
                                                  onClick={() => {
                                                    setIsCorrect(false);
                                                    setIsThumbsUpPopup(false);
                                                    handleMandatoryCheckFeedback(
                                                      item,
                                                      itm,
                                                      feedbackPresent,
                                                      "mandatoryChecks"
                                                    );
                                                  }}
                                                />
                                              </div>
                                            )}
                                            {itm?._id === openReasonPopup && (
                                              <FeedbackPopup
                                                align="right-0"
                                                elementData={componentFeedback}
                                                setElementData={
                                                  setComponentFeedback
                                                }
                                                handleFeedback={handleFeedback}
                                                setState={() => {
                                                  setOpenReasonPopup(null);
                                                  setIsThumbsUpPopup(false);
                                                }}
                                                handleUpdateFeedback={
                                                  handleUpdateFeedback
                                                }
                                                isForCorrect={isCorrect}
                                                edit={
                                                  feedbackPresent ? true : false
                                                }
                                                callUpdate={
                                                  feedback ? true : false
                                                }
                                                clearData={ClearData}
                                                isThumbsUp={isThumbsUpPopup}
                                              />
                                            )}
                                          </div>
                                        </div>
                                      </div>
                                    );
                                  })}
                                </div>
                              </div>
                            )}
                            {filterQuestionText?.length > 0 && (
                              <div className="w-full  px-6 py-2">
                                <div className="flex w-full justify-between">
                                  <div className="relative flex w-full gap-2">
                                    <span className="font-InterRegular text-ft14-17 text-black-20">
                                      Additional Questions
                                    </span>

                                    <ClickOutside
                                      isOpen={tooltip}
                                      onClickOutside={() => setTooltip(false)}
                                    >
                                      <IoInformationCircleOutline
                                        onClick={() => setTooltip(!tooltip)}
                                        className="size-5 cursor-pointer text-black-0"
                                      />
                                      {tooltip && (
                                        <div className="shadow-lg absolute bottom-7 left-36  w-[500px] rounded-lg border border-grey-10 bg-white px-3 py-2">
                                          <div>
                                            <span className="font-InterMedium text-ft14-17 text-black-10">
                                              Additional Questions
                                            </span>
                                            <div className="rounded-md bg-grey-110 p-3">
                                              {filterQuestionText.map(
                                                (item, idx) => (
                                                  <div
                                                    key={idx}
                                                    className="flex items-start justify-between border-b border-grey-10 px-1 py-2 last:border-0 last:pb-0"
                                                  >
                                                    {/* Left Side - Question + Meta */}
                                                    <div className="pr-4">
                                                      <p className="font-InterRegular text-ft14-17 text-black-10">
                                                        {item.questionText}
                                                      </p>
                                                      <div className="mt-1 flex gap-5">
                                                        {item?.modelInfo
                                                          ?.modelFamily && (
                                                          <div className="flex gap-1">
                                                            <span className="font-InterRegular text-ft12-16 text-black-10">
                                                              Model:
                                                            </span>
                                                            <span className="text-ft12-16 font-semibold text-black-10">
                                                              {item?.modelInfo
                                                                ?.modelId ||
                                                                "—"}{" "}
                                                            </span>
                                                          </div>
                                                        )}
                                                        <div className="flex gap-1">
                                                          <span className="font-InterRegular text-ft12-16 text-black-10">
                                                            Fallback:
                                                          </span>
                                                          <span className="text-ft12-16 font-semibold text-black-10">
                                                            {item?.modelInfo
                                                              ?.fallbackUsed
                                                              ? "Yes"
                                                              : "No"}
                                                          </span>
                                                        </div>
                                                      </div>
                                                    </div>

                                                    {/* Right Side - Answer */}
                                                    <div className="font-InterMedium text-ft14-17 text-black-10">
                                                      {item.answer || "—"}
                                                    </div>
                                                  </div>
                                                )
                                              )}
                                            </div>
                                          </div>
                                        </div>
                                      )}
                                    </ClickOutside>
                                  </div>

                                  <span
                                    className={`font-InterRegular text-ft14-17 ${item?.systemResults === "Approved" ? "text-green-10" : "text-red-10"} `}
                                  >
                                    {item?.systemResults}
                                  </span>
                                </div>

                                <div className="flex flex-col gap-3 rounded-md bg-grey-110 p-4">
                                  {filterQuestionText?.map((itm, idx) => {
                                    const feedbackPresent =
                                      item?.additionalFeedback?.find(
                                        (value) =>
                                          value.questionText ===
                                            itm?.questionText &&
                                          value.componentName ===
                                            item?.componentName
                                      );

                                    return (
                                      <div
                                        key={idx}
                                        className="flex justify-between"
                                      >
                                        <span className="w-85per font-InterRegular text-ft14-17 text-black-10">
                                          {itm.questionText}
                                        </span>
                                        <div className="flex gap-2">
                                          <span className="font-InterMedium text-ft14-17 text-black-10">
                                            {itm?.answer === "y"
                                              ? "Yes"
                                              : itm?.answer === "n"
                                                ? "No"
                                                : Utils.formatText(itm.answer)}
                                          </span>
                                          <div className="relative cursor-pointer">
                                            {feedbackPresent ? (
                                              feedbackPresent?.feedback !==
                                                "CORRECT" &&
                                              feedbackPresent?.feedback !==
                                                "GEN_AI_CORRECT_INSUFFICIENT_INPUTS" ? (
                                                <img
                                                  onClick={() => {
                                                    setIsCorrect(false);
                                                    setIsThumbsUpPopup(false);
                                                    handleMandatoryCheckFeedback(
                                                      item,
                                                      itm,
                                                      feedbackPresent,
                                                      "additionalQuestions"
                                                    );
                                                  }}
                                                  src="/images/red-thumbs-down.svg"
                                                  alt=""
                                                  className="cursor-pointer"
                                                />
                                              ) : (
                                                <FaThumbsUp
                                                  onClick={() => {
                                                    setIsCorrect(false);
                                                    setIsThumbsUpPopup(true);
                                                    handleMandatoryCheckFeedback(
                                                      item,
                                                      itm,
                                                      feedbackPresent,
                                                      "additionalQuestions"
                                                    );
                                                  }}
                                                  className={`cursor-pointer ${feedbackPresent?.feedback === "GEN_AI_CORRECT_INSUFFICIENT_INPUTS" ? "text-black-0" : ""}`}
                                                />
                                              )
                                            ) : (
                                              <div className="flex gap-2">
                                                <LuThumbsUp
                                                  onClick={() => {
                                                    setIsCorrect(true);
                                                    handleMandatoryCheckFeedback(
                                                      item,
                                                      itm,
                                                      feedbackPresent,
                                                      "additionalQuestions",
                                                      true
                                                    );
                                                  }}
                                                  className="cursor-pointer"
                                                />
                                                <LuThumbsDown
                                                  onClick={() => {
                                                    setIsCorrect(false);
                                                    setIsThumbsUpPopup(false);
                                                    handleMandatoryCheckFeedback(
                                                      item,
                                                      itm,
                                                      feedbackPresent,
                                                      "additionalQuestions"
                                                    );
                                                  }}
                                                  className="cursor-pointer"
                                                />
                                              </div>
                                            )}
                                            {itm?._id === openReasonPopup && (
                                              <FeedbackPopup
                                                align="right-0"
                                                elementData={componentFeedback}
                                                setElementData={
                                                  setComponentFeedback
                                                }
                                                handleFeedback={handleFeedback}
                                                setState={() => {
                                                  setOpenReasonPopup(null);
                                                  setIsThumbsUpPopup(false);
                                                }}
                                                handleUpdateFeedback={
                                                  handleUpdateFeedback
                                                }
                                                edit={
                                                  feedbackPresent ? true : false
                                                }
                                                callUpdate={
                                                  feedback ? true : false
                                                }
                                                clearData={ClearData}
                                                isForCorrect={isCorrect}
                                                isThumbsUp={isThumbsUpPopup}
                                              />
                                            )}
                                          </div>
                                        </div>
                                      </div>
                                    );
                                  })}
                                </div>
                              </div>
                            )}
                          </div>
                        ) : (
                          <div className="mx-4 my-2 h-full rounded-md bg-grey-110 p-4 font-InterRegular text-ft14-17  text-black-10">
                            <span>{item.reason}</span>
                          </div>
                        )}
                      </td>
                    </tr>
                  </>
                )}
              </>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default ComponentTable;
